
<div class="main-container-side">
<div class="d-flex flex-column info-container">
  <div class='header-img'>
    <img src="assets/images/white-logo.png" alt="logo">
  </div>
</div>
<div class="d-flex flex-column content-center">
    <div class='header-middle-img'>
      <img src="assets/images/header_middle_img.png" alt="logo">
    </div>
    <p>{{ 'store.auth.sideTagline' | translate }}</p>
    <p class="p1">{{ 'store.auth.sideSubline' | translate }}</p>

  </div>
<p class="bottom">{{ 'store.auth.rights' | translate }}</p>
</div>
